import React from "react";
import ReportStatCard from "./ReportStatCard";

const CourierReportCards = ({ data }) => {
  return (
    <>
      <ReportStatCard
        title="Shipments"
        value={data.shipments.toLocaleString("en-IN")}
        subtitle="Total shipments"
        icon="fas fa-box"
        iconClass="bg-primary"
      />

      <ReportStatCard
        title="Delivered"
        value={`${data.deliveredPercentage}%`}
        subtitle="Delivery success"
        icon="fas fa-check-circle"
        iconClass="bg-success"
      />

      <ReportStatCard
        title="In Transit"
        value={data.inTransit.toLocaleString("en-IN")}
        subtitle="Currently in transit"
        icon="fas fa-shipping-fast"
        iconClass="bg-info"
      />

      <ReportStatCard
        title="RTO"
        value={`${data.rtoPercentage}%`}
        subtitle="Return to origin"
        icon="fas fa-undo"
        iconClass="bg-danger"
      />

      <ReportStatCard
        title="Total Freight Paid"
        value={`₹${data.totalFreightPaid.toLocaleString("en-IN")}`}
        subtitle="Paid to courier"
        icon="fas fa-truck"
        iconClass="bg-warning"
        valueClass="text-dark"
      />

      <ReportStatCard
        title="Freight Collected"
        value={`₹${data.freightCollected.toLocaleString("en-IN")}`}
        subtitle="Collected from customers"
        icon="fas fa-money-bill"
        iconClass="bg-success"
      />

      <ReportStatCard
        title="Shipping Gain / Loss"
        value={`₹${data.shippingGainLoss.toLocaleString("en-IN")}`}
        subtitle="Shipping margin"
        icon="fas fa-chart-line"
        iconClass={
          data.shippingGainLoss >= 0
            ? "bg-success"
            : "bg-danger"
        }
        valueClass={
          data.shippingGainLoss >= 0
            ? "text-success"
            : "text-danger"
        }
      />
    </>
  );
};

export default CourierReportCards;